import { render, staticRenderFns } from "./PlanStats.vue?vue&type=template&id=1b148106&"
import script from "./PlanStats.vue?vue&type=script&lang=js&"
export * from "./PlanStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports